import * as React from 'react';

import View16 from './View16';

export const view16 = () => <View16 />;

export default {
    title: 'Icon/Line/View16',
    component: View16,
    parameters: {
        notes: "`import View16 from 'box-ui-elements/es/icon/line/View16';`",
    },
};
